/**
 * Web Style Import
 *
 */

import './dnb-heading.scss'
